import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AboutComponent} from "./front/pages/about/about.component";
import {FleetInfoComponent} from "./front/pages/fleet-info/fleet-info.component";
import {FleetInfoQ88Component} from "./front/pages/fleet-info-q88/fleet-info-q88.component";
import { ContactComponent } from "./front/pages/contact/contact.component";
import {HomeComponent} from "./front/pages/home/home.component";
import {TrackComponent} from "./front/pages/track/track.component";
import { TermOfUseComponent} from "./front/pages/term-of-use/term-of-use.component";
import { PrivacyPolicyComponent} from "./front/pages/privacy-policy/privacy-policy.component";
import { AccessibilityComponent} from "./front/pages/accessibility/accessibility.component";
import { FourZeroFourComponent} from "./front/pages/four-zero-four/four-zero-four.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { FleetInfoIframeComponent } from './front/pages/fleet-info-iframe/fleet-info-iframe.component';
import { ContactIframeComponent } from './front/pages/contact-iframe/contact-iframe.component';
import { OurfleetExternalComponent } from './front/pages/ourfleet-external/ourfleet-external.component';
import { FleetInfoQ88IframeComponent } from './front/pages/fleet-info-q88-iframe/fleet-info-q88-iframe.component';
import { SnitsComponent } from './front/pages/snits/snits.component';
import { EnquiryFormComponent } from './front/pages/enquiry-form/enquiry-form.component';
import { GlobalSearchComponent } from './front/pages/global-search/global-search.component';
import { DownloadDocumentComponent } from './front/pages/download-document/download-document.component';
import { SettingPocComponent } from './front/pages/setting-poc/setting-poc.component';
import { ThankYouComponent } from './front/pages/thank-you/thank-you.component';
import { CalendarPreviewComponent } from './front/pages/calendar-preview/calendar-preview.component';
import { EtbOtpVerificationComponent } from './front/pages/etb-otp-verification/etb-otp-verification.component';
import { PortAgentEtbDetailUpdateComponent } from './front/pages/port-agent-etb-detail-update/port-agent-etb-detail-update.component';
import { ThankYouFormComponent } from './front/pages/thank-you-form/thank-you-form.component';
import { ErrorComponent } from './front/pages/error/error.component';
const routes: Routes = [
 
  {
    path: "about",
    component: AboutComponent
  },
  {
    path: 'fleetinfo',
    component: FleetInfoComponent,
  },
  {
    path: 'Q88/:id',
    component: FleetInfoQ88Component,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'setting',
    component: SettingPocComponent,
  },
  {
    path: 'setting-snl-poc',
    component: SettingPocComponent,
  },
  {
    path: 'search',
    component: GlobalSearchComponent,
  },
  {
    path: 'track/:id',
    component: TrackComponent,
  },
  {
    path: 'port-berth/:id',
    component: EtbOtpVerificationComponent,
  },
  {
    path: 'port-agent-etb-detail-update/:id',
    component: PortAgentEtbDetailUpdateComponent,
  },
  {
    path: 'view-berths-schedules/:id',
    component: CalendarPreviewComponent,
  },
  {
    path: "booking",
    loadChildren: () => import("./front/pages/pages.module").then(m => m.PagesModule)
  },
  {
    path: "berths-schedules",
    loadChildren: () => import("./front/etb-berth-schedules/etb-berth-schedules.module").then(m => m.EtbBerthSchedulesModule),
  },
  {
    path: "terms-of-use",
    component: TermOfUseComponent
  },
  {
    path: "privacy-and-cookies",
    component: PrivacyPolicyComponent
  },
  {
    path: "accessibility",
    component: AccessibilityComponent
  },
  {
    path: 'fleetinfo-external',
    component: FleetInfoIframeComponent,
  },
  {
    path: 'contact-external',
    component: ContactIframeComponent,
  },
  {
    path: 'ourfleet-external',
    component: OurfleetExternalComponent,
  },
  {
    path: 'fleet/vessel',
    component: FleetInfoQ88IframeComponent,
  },
  {
    path: 'fleetinfo/snits',
    component: SnitsComponent,
  },
  {
    path: 'fleetinfo/enquiryform',
    component: EnquiryFormComponent,
  },
  {
    path: 'documets-download',
    component: DownloadDocumentComponent,
  },
  {
    path: 'thank-you',
    component: ThankYouComponent
  },
  {
    path: 'thank_you',
    component: ThankYouFormComponent,
  },
  {
    path: '404',
    component: FourZeroFourComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '',
    component: HomeComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: '' },
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration: 'enabled'}),NgSelectModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
